import { TranslationService } from "../../../services/TranslationService";
import { getActionMeta } from "../utils/agendaUtils";

/** Action pill: icon + label, colored per action; generic icon for unknown actions. */
const AgendaActionPill = ({ action }: { action: number }) => {
  const meta = getActionMeta(action);
  return (
    <span className={`agenda-action agenda-action--${meta.kind}`}>
      <i className={`${meta.icon} fa-fw`} aria-hidden="true" />
      {TranslationService.getTranslation(meta.labelKey)}
    </span>
  );
};

export default AgendaActionPill;
